import { useState } from "react"
import axios from "axios"
import useUser from "../hooks/useUser"

const AddCommentForm = ({articleName, onArticleUpdated}) => {
  
  const [name, setName] = useState('')
  const [commentText, setCommnetText] = useState('')
  const {user} = useUser()

  const addComment = async () =>{
    const token = user && await user.getIdToken();
      const headers = token ? { authtoken: token } : {};
    const response = await axios.post(`/api/articles/${articleName}/comments`,{
        postedBy: name,
        text: commentText,
    },{
      headers,
    })
    const updatedArticle = response.data;
    onArticleUpdated(updatedArticle);
    setName('')
    setCommnetText('')
  }
  return (
    <div id="add-comment-form">
        <h3>Add a Comment</h3>
        <label>
            Name:
            <input 
                value={name}
                onChange={e =>setName(e.target.value)}
                type="tex"/>
        </label>
        <label>
            Comment:
            <textarea 
                    value={commentText}
                    onChange={e =>setCommnetText(e.target.value)}
                    rows="4" cols="50" />
        </label>
        <button onClick={addComment}>Add Comment</button>
    </div>
  )
}

export default AddCommentForm